export function getGeoLogDeleteToken(relativeKey: string): string {
  const s3Key = `public/${relativeKey}`;
  const bytes = new TextEncoder().encode(s3Key);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}
